export default {
  "termsOfUse": "Умови використання",
  "goToHome": "Повернутися на головну сторінку",
  "choose": "Вибрати",
  "close": "Закрити",
  "yes": "Так",
  "no": "Ні",
  "moreInfo": "Додаткова інформація",
  "send": "Відправити",
  "sendProcess": "Відправлення",
  "sendSuccess": "Відправлено",
  "actual": "На даний момент",
  "question": "Проконсультуватись з лікарем",
  "appointment": "Звернутись до лікаря",
  "freeDownload": "Скачайте наш додаток безкоштовно",
  "downloadAppStore": "Скачайте в App Store",
  "downloadGooglePlay": "Скачайте в Google Play",
  "month": "Місяць",
  "year": "Рік",
  "other": "Інше",
  "backToStart": "Повернутися додому",
  "backToOverview": "повернутися до огляду послуг",
  "or": "або",
  "czechLanguage": "чеська",
  "slovakLanguage": "словацька",
  "englishLanguage": "англійська",
  "goNext": "Продовжувати",
  "goPrev": "назад",
  "save": "Зберегти",
  "show": "Показати",
  "showMore": "Показати більше",
  "showAll": "Показати все",
  "saveChanges": "Зберегти зміни",
  "saveChangesProcess": "Зберігання",
  "saveChangesSuccess": "Збережено",
  "loginText": "Авторизуватись",
  "contact": "Контакт",
  "done": "Зроблено",
  "finish": "Завершено",
  "skip": "Пропустити",
  "legalDocuments": "Юридичні документи",
  "new": "Новини",
  "free": "Безкоштовно",
  "tryAgain": "Зпробувати знову",
  "until": "поки",
  "pilot": "Відеодзвінок",
  "here": "тут",
  "currency": "Kč",
  "agree": "Я згоден",
  "disagree": "Не погоджуюсь",
  "alertInfo": {
    "title": "Медична консультація uLékaře.cz не замінює швидку допомогу",
    "text": "При терміновій необхідності <a href='tel:155'>телефонуйте 155 або 112</a>",
    "iAgree": "Я розумію",
    "errorText": "Це поле обов язкове для заповнення"
  },
  "uLekare": {
    "title": "uLékaře.cz"
  },
  "partners": {
    "otherPartners": "Партнери"
  },
  "questionForm": {
    "title": "Ваше запитання до лікаря",
    "subtitle": "Що Вас турбує, як довго триває проблема, чи приймаєте ви якісь ліки, чи вже було проведено якесь обстеження, ...",
    "modalTitle": "Додайте фотографії або медичні висновки",
    "send": "Відправити до лікаря",
    "back": "Повернутися до запиту",
    "sendTitle": "Дякуємо Вам за відправку Вашого запиту",
    "next": "Продовжити",
    "sendPerex": "Дякуємо Вам за ваш візит у віртуальний зал очікування.",
    "question": {
      "placeholder": "Напишіть тут, що Вас турбує",
      "errorText": "Будь ласка, задайте питання лікарю, щоб він міг проконсультувати вас."
    },
    "firstName": {
      "title": "Ім'я",
      "placeholder": "Напишіть ім'я",
      "helpText": "Ім'я буде відображатися в запиті на сайті.",
      "helpTextNotShowing": "Медична команда зв'яжеться з вами, тому їм потрібне ваше ім'я.",
      "errorText": "Потрібне ім'я, будь ласка, заповніть."
    },
    "lastName": {
      "title": "Прізвище",
      "placeholder": "Напишіть прізвище",
      "helpText": "Медична команда зв'яжеться з вами, тому їм потрібне ваше прізвище.",
      "errorText": "Прізвище обов'язкове, будь ласка, заповніть."
    },
    "email": {
      "title": "Електронна пошта",
      "placeholder": "jmeno@priklad.cz",
      "helpText": "Ми надішлемо вам інформацію від медичної бригади на цю адресу електронної пошти.",
      "hrbHelpText": "Ми рекомендуємо вам вказати особисту адресу електронної пошти.",
      "errorText": "Потрібна адреса електронної пошти, будь ласка, заповніть.",
      "errorEmailText": "Електроннa пошта не в правильному форматі, будь ласка, перевірте.",
      "errorEmailNotExisting": "Цієї адреси не існує. Будь ласка, вкажіть вашу існуючу адресу електронної пошти.",
      "invalidBenefitEmail": "Неправильна адреса електронної пошти"
    },
    "phone": {
      "title": "Телефон",
      "placeholder": "123 456 789",
      "helpText": "Медсестра може запропонувати вам записатися на прийом до лікаря.",
      "errorText": "Номер телефону обов'язковий, будь ласка, заповніть його.",
      "errorPhoneText": "Введіть свій номер телефону ({exampleNumber})."
    },
    "emailphone": {
      "errorEmailText": "Потрібна адреса електронної пошти, будь ласка, заповніть.",
      "errorPhoneText": "Потрібен номер телефону, будь ласка, заповніть."
    },
    "birthYear": {
      "title": "Рік народження",
      "titleRegistered": "Рік народження",
      "helpText": "Вкажіть рік народження відповідної особи.",
      "errorText": "Рік народження обов'язковий, будь ласка, заповніть.",
      "errorLengthText": "Рік народження напишіть у форматі xxxx (напр. 1989).",
      "errorBetweenText": "Напишіть фактичний рік народження. :)"
    },
    "pastYear": {
      "errorLengthText": "Рік народження напишіть у форматі xxxx (напр. 1989)",
      "errorBetweenText": "Напишіть фактичний рік народження. :)",
      "errorText": "Рік народження обов'язковий, будь ласка, заповніть."
    },
    "zipCode": {
      "title": "Поштовий індекс",
      "helpText": "За поштовим індексом ми порекомендуємо, куди вам записатися.",
      "errorText": "Потрібен поштовий індекс, будь ласка, заповніть.",
      "errorZipCodeText": "Поштовий індекс вказано невірно."
    },
    "insuranceCompany": {
      "title": "Страхова компанія",
      "errorText": "Потрібна страхова компанія, будь ласка, заповніть.",
      "selectInsuranceCompany": "Виберіть свою страхову компанію"
    },
    "timeAvailability": {
      "title": "Ваш вільний час",
      "errorText": "Поле обов'язково для заповнення. Будь ласка, вкажіть наявність часу.",
      "placeholder": "Запишіть, які у вас є варіанти вільного часу в найближчі дні."
    },
    "selectedBranchValue": {
      "title": "Ординація",
      "selectInsuranceCompany": "Виберіть ординацію"
    },
    "personalId": {
      "title": "Номер застрахованої особи",
      "helpText": "Щоб підтвердити, що Ви належите до цього лікаря загальної практики.",
      "errorText": "Страховий номер є обов'язковим, будь ласка, заповніть його."
    },
    "checkedMyDoctor": "Я підтверджую, що це мій лікар загальної практики"
  },
  "fileUpload": {
    "initial": "Натисніть ВИБРАТИ і виберіть файли чи перенесіть їх.",
    "typeError": "Даний тип файлу не підходить. Додавайте файли типу .jpg, .png.",
    "sizeError": "Перевищений максимально дозволений розмір. Максимальний розмір одного файлу 20МВ цілком 100МВ.",
    "totalSizeError": "Максимальний розмір файлу цілком 100МВ."
  },
  "footer": {
    "copyright": "&copy; 2007-{thisYear} uLékaře.cz, s.r.o.",
    "issn": "ISSN 1802-5544",
    "companyTitle": "Компанія uLékaře.cz",
    "companyList": [
      {
        "title": "Контакт"
      },
      {
        "title": "Кар'єра",
        "linkType": "external",
        "target": "_blank",
        "forCompanies": "false",
        "aeskulab": "false"
      },
      {
        "title": "Реклама",
        "link": "https://www.ulekare.cz/inzerce",
        "linkType": "external",
        "target": "_blank",
        "forCompanies": "false",
        "aeskulab": "false"
      },
      {
        "title": "Здоров’я та профілактика у компанії",
        "partnerLink": "forCompanies",
        "thematicCounsellingLink": "forCompanies",
        "target": "_blank",
        "forCompanies": "false",
        "aeskulab": "false"
      },
      {
        "title": "Обробка персональних даних",
        "link": "personalDataProcessing",
        "partnerLink": "hrbPersonalDataProcessing",
        "thematicCounsellingLink": "thematicCounsellingPersonalDataProcessing",
        "forCompaniesLink": "forCompaniesPersonalDataProcessing",
        "aeskulabLink": "aeskuLabPersonalDataProcessing"
      },
      {
        "title": "Умови використання",
        "link": "termsAndConditions",
        "partnerLink": "hrbTermsAndConditions",
        "thematicCounsellingLink": "thematicCounsellingTermsAndConditions",
        "forCompaniesLink": "forCompaniesTermsAndConditions",
        "aeskulabLink": "aeskuLabTermsAndConditions"
      },
      {
        "title": "Заява про файли cookie",
        "link": "cookies",
        "partnerLink": "hrbCookies",
        "thematicCounsellingLink": "thematicCounsellingCookies",
        "forCompaniesLink": "forCompaniesCookies",
        "aeskulabLink": "aeskuLabCookies"
      }
    ],
    "perex": {
      "rsAssistant": "Найбільша Чеська медична онлайн-клініка і піонер у галузі телемедицини прагне оптимізувати та покращити охорону здоров'я Чехії.<br/><br/>CZ2212160829/12/2022",
      "astmaHelp": "Найбільша чеська медична онлайн-клініка і піонер у галузі телемедицини прагне оптимізувати та покращити охорону здоров'я Чехії."
    }
  },
  "dataProcessing": {
    "iAgree": "Я згоден",
    "iAgreeWith": "Я згоден з",
    "privacyPolicy": "обробкою персональних даних",
    "privacyPolicyTitle": "Згода на обробку персональних даних, включаючи спеціальні категорії персональних даних",
    "newsletterProcessing": "розсилкою новин та знижок uLékaře.cz.",
    "newsletterText": "Я згоден отримувати маркетингові повідомлення uLékaře.cz (з новинами компанії та проекту uLékaře.cz, продуктами і послугами співпрацюючих третіх осіб s. r. o.). Ви можете відкликати свою згоду, вибравши в розсилці або за адресою <a href=\"mailto:osobniudaje@ulekare.cz\">osobniudaje@ulekare.cz</a>.",
    "conferenceNewsletterAgreement": "розсилкою повідомлень, пов'язаних з тематикою конференції",
    "conferenceNewsletterTitle": "Згода на отримання інформаційних електронних листів (новинних листів)",
    "conferenceDataTitle": "Я згоден з обробкою персональних даних",
    "termsConditions": "умовами використання",
    "privacyPolicyInAccordance": "Особисті дані обробляються відповідно до"
  },
  "termsAndConditions": {
    "title": "Умови використання"
  },
  "personalDataProcessing": {
    "title": "Згода на обробку персональних даних"
  },
  "newsletter": {
    "title": "Згода на отримання маркетингових повідомлень"
  },
  "errorLayout": {
    "title": "Ой, цей сайт хворий!",
    "text": "Вибачте, ця сторінка вже в операційній . Ми скоро це виправимо, будь ласка, повторіть спробу пізніше.",
    "button": "Повернутися на головну сторінку"
  },
  "meta": {
    "termsAndConditions": {
      "title": "Конкретні умови користування вебсайтом uLekaře.cz"
    },
    "personalDataProcessing": {
      "title": "Принципи захисту персональних даних"
    },
    "emergency": {
      "title": "Коли звертатись за невідкладною допомогою",
      "description": "Короткий список гострих чи небезпечних для життя станів, про які ми хочемо попередити пацієнтів, щоб направити найбільш невідкладних у відділення невідкладної допомоги."
    },
    "putinSucks": {
      "title": "Лікарське консультування для біженців з України",
      "description": "Безкоштовна допомога та запис по всій Чехії. Персонал говорить на українській та російській мовах."
    },
    "login": {
      "title": "Вхід",
      "description": "Зареєструйтесь, щоб завжди під рукою мати медичну допомогу. Ми будемо раді допомогти вам записатися на прийом до лікаря в Чехії та Словаччині. Здоров'я - ваше."
    },
    "aeskulab": {
      "title": "Мої результати аналізів"
    },
    "dashboard": {
      "title": "Здоров'я онлайн"
    },
    "dashboardQuestions": {
      "title": "Поради"
    },
    "dashboardAppointments": {
      "title": "Запис на прийом до лікаря"
    },
    "dashboardArticles": {
      "title": "Журнал «Відкрий для себе"
    },
    "dashboardConsultations": {
      "title": "Відповідають лікарі"
    },
    "dashboardPrevention": {
      "title": "Моя профілактика"
    },
    "dashboardProfile": {
      "title": "Мій профіль здоров'я"
    },
    "lostPassword": {
      "title": "Забули пароль"
    },
    "passwordReset": {
      "title": "Відновлення пароля"
    },
    "emailVerification": {
      "title": "Перевірка електронної пошти"
    },
    "registration": {
      "title": "Зареєструватися"
    }
  },
  "emergency": {
    "title1": "Коли звернутися за невідкладною допомогою",
    "perex": "Звертаємо Вашу увагу на список невідкладних станів, які можуть становити загрозу життю. Мета полягає в тому, щоб негайно направити пацієнтів на екстрену допомогу, уникнувши затримок у чеканні на відповідь від лікаря. Необхідно особливу увагу приділити дітям.",
    "list": [
      {
        "title": "Травми та кровотечі",
        "body": [
          " велика кровотеча, або <strong>яскраво-червона пульсуюча кров</strong>",
          "сильна кровотеча із статевих органів поза менструальним циклом або ректальна кровотеча",
          "відкритий чи помітний перелом ",
          "<strong>відкрита рана</strong> на грудях чи в животі\"",
          "<strong>поранення голови</strong> з порушенням свідомості, змінами в поведінці, головними болями, нудотою, різним розміром зірниць, порухою мови, зору або рухів",
          "<strong>опіки у дітей</strong> насамперед на голові або руках, геніталіях, або враження великої частини тіла у дорослої людини",
          "ураження <strong>електричним струмом або блискавкою</strong>"
        ]
      },
      {
        "title": "Грудний біль та інші симптоми",
        "body": [
          " грудний біль, який <strong>не припиняється</strong>, не реагує на звичайні ліки від болю, або який посилюється, має <strong>стискаючий характер</strong>",
          "<strong>віддає</strong> до лівого плеча або шиї",
          "біль або <strong>аритмія, які супроводжуються свідомості</strong> та можливим зомлінням",
          "якщо подібні симптоми повторюються, або Ви лікуєтесь з серцево-судинним захворюванням",
          "грудний  біль із задишкою та виразними змінами тиску"
        ]
      },
      {
        "title": "Задишка",
        "body": [
          "ускладнення дихання, відчуття <strong>недостатньої глибини дихання</strong>",
          "<strong>поверхневе дихання</strong> (як у риби), свистячий видих",
          "неспроможність закінчити речення без вдиху, необхідність опори або сидіння для покращення дихання, втягування яремної ямки та надключиць",
          "<strong>зміна кольору</strong> губ, вух або пальців на фіолетову"
        ]
      },
      {
        "title": "Головні болі",
        "body": [
          "біль, який є <strong>сильним, незвичайним, різким</strong>, не реагує на ліки",
          "<strong>будить зі сну</strong>, або настає відразу після пробудження",
          "різкому болю передувало фізичне навантаження, включаючи статеві навантаження",
          "біль, що супроводжується напруженням м’язів шиї, слабкістю, сонливістю, порушенням свідомості, лихоманкою",
          "головний біль, який триває впродовж наступних днів після травми голови, особливо з порухою свідомості, блювотою, слабкістю",
          "супроводжується <strong>порухою зору, мовлення, рухів</strong>"
        ]
      },
      {
        "title": "Болі в животі та інші симптоми шлунково-кишкового тракту",
        "body": [
          "<strong>сильний біль або коліка</strong>",
          "<strong>закреп</strong> та порушення відходу газів із здуттям, болем",
          "чорний колір стільця",
          "<strong>блювання кров’ю</strong>",
          "<strong>шишка на животі</strong>, в паху, на яєчку, яка болить, на неї не можна тиснути (не намагайтеся це зробити), відрізняється за кольором"
        ]
      },
      {
        "title": "Зомління, порушення свідомості, судоми",
        "body": [
          "раптове зомління, падіння, після якого людина не приходить до тями, або не поводить себе нормально",
          "стан з <strong>порушенням свідомості, мови, зору, рухів кінцівок</strong>",
          "<strong>судоми всього тіла</strong>"
        ]
      },
      {
        "title": "Інфекції та лихоманки",
        "body": [
          "стани з <strong>лихоманкою над 40°C, яка не реагує на дозу ліків у відповідності до маси тіла</strong>",
          "<strong>дитину морозить, судоми при гарячці</strong>",
          "повторна, <strong>невгамовна блювота та діарея у дітей</strong>, недостатній прийом рідин у дітей",
          "інфекція, супроводжена загальними змінами стану/поведінки: сонливість, апатія, втрата апетиту та відчуття спраги"
        ]
      },
      {
        "title": "Алергія та набряки",
        "body": [
          "<strong>набряк обличчя, шиї та горла, набряк язика</strong>",
          "<strong>задишка</strong>",
          "<strong>труднощі з ковтанням</strong>",
          "висипання або набряк всього тіла",
          "односторонній, насамперед супроводжений болем, набряк кінцівки з можливим сухим кашлем або ускладненим диханням"
        ]
      },
      {
        "title": "Невідкладна стоматологічна допомога",
        "body": [
          "зубний біль в супроводі з головним болем",
          "зубний біль з температурою",
          "набряк щоки та області зубів, що розповсюджується на шию, можливо супроводжується утрудненим ковтанням.\""
        ]
      },
      {
        "title": "Злочини",
        "body": [
          "якщо Ви підозрюєте злочин - дзвоніть 112",
          "якщо Ваше життя або когось з Вашого оточення знаходиться під загрозою внаслідок злочину, телефонуйте за номером 112",
          "якщо мова йде про знущання, фізичне чи психічне насилля, телефонуйте за номером 112.\""
        ]
      },
      {
        "title": "Психіка",
        "body": [
          "якщо мова йде про раптовий стан розгубленості, зміни поведінки, агресивність, викличте швидку допомогу",
          "якщо існує загроза самогубства, негайно викличте швидку допомогу"
        ]
      }
    ],
    "title2": "Дзвоніть 155",
    "title": "Коли звернутися за невідкладною допомогою"
  },
  "emergencyInfo": {
    "titleQuestion": "Перш ніж поставити питання",
    "titleonco-prevention": "Перш ніж поставити питання",
    "titleOrder": "Перш ніж зробити замовлення",
    "subtitle": "Послуга uLékaře.cz не замінює службу екстреної допомоги.<br /><a href=\"{link}\" target=\"_blank\" class=\"black--text link--inline\">Коли викликати швидку допомогу?</a>",
    "services": "У гострих і небезпечних для життя ситуаціях завжди <a href=\"tel:155\" class=\"link--inline black--text\">телефонуйте за номерами 155 або 112</a>.",
    "continueQuestion": "Продовжте запит",
    "continueOrder": "Далі в порядку",
    "dynamicForms": {
      "linkText": "Коли звертатися за невідкладною допомогою"
    }
  },
  "reauthorizationDashboard": {
    "partnerText": "Послуга uLékaře.cz все ще оплачується {currentPartnerName}.",
    "prolongText": "Продовжіть свої переваги uLékaře.cz, щоб зберегти їх безкоштовними.",
    "prolongFamilyText": "Нагадайте вашій близькій людині, що ви хочете продовжити послугу.",
    "buttonText": "Продовжити безкоштовно",
    "inDay": "дня",
    "inDaysLow": "днів",
    "inDaysHigh": "днів",
    "selfPayNowHeading": "Тепер ти сам за себе платиш. Але ти не зобов'язаний ним бути.",
    "selfPayNowPartnerText": "Кто будет платить за uLékaře.cz? Это может быть ваш работодатель, страховая компания и.т.д.",
    "selfPayNowProlongText": "Расширьте свои льготы, чтобы получить услугу бесплатно. Как и раньше.",
    "selfPayNowFamilyPartnerText": "Нагадайте своїй близькій людині {currentPartnerName}.",
    "selfPayNowFamilyPartnerInfoText": "Коли він поновить свою послугу на uLékaře.cz, ви отримаєте всі свої переваги назад безкоштовно."
  },
  "hrbPage": {
    "contactUs": {
      "title": "Обслуговування клієнтів",
      "subTitle": "Потребуєте порадити? Потрібна допомога у заповненні форми?"
    },
    "covidLink": {
      "title": "Інформаційна лінія щодо Covid",
      "callUs": "Зателефонуйте нам",
      "tooltip": {
        "title": "Що ми можемо вам порадити?",
        "text": [
          "Симптоми захворювання",
          "Групи ризику",
          "Коронавірус і вагітність",
          "Тестування",
          "Профілактичні та гігієнічні заходи"
        ]
      }
    }
  },
  "authorization": {
    "title": "Активація послуги",
    "subtitle": "Введіть адресу електронної пошти вашої компанії або код, який ви отримали від роботодавця, і дотримуйтесь інструкцій. Сервіс uLékaře.cz вже в межах досяжності!",
    "subtitleEmail": "Введіть адресу електронної пошти вашої компанії або код, який ви отримали від роботодавця, і дотримуйтесь інструкцій. Сервіс uLékaře.cz вже в межах досяжності!",
    "subtitleCode": "Введіть адресу електронної пошти вашої компанії або код, який ви отримали від роботодавця, і дотримуйтесь інструкцій. Сервіс uLékaře.cz вже в межах досяжності!",
    "emailLabel": "Електронна пошта",
    "codeLabel": "Код",
    "codeHrbError": "Недійсний код",
    "codeLengthError": "Код повинен містити 2-20 символів.",
    "or": "або",
    "contactTitle": "Хочете порадитись?",
    "sendMessage": "У вашому електронному листі ви знайдете повідомлення від uLékaře.cz. натисніть на посилання, що міститься всередині, це підтвердить доступ до сервісу.",
    "changeEmail": "Змінити адресу електронної пошти"
  },
  "checkToken": {
    "generateToken": "Надіслати нове посилання",
    "expired": {
      "title": "Посилання неактивне",
      "perex": "З питань безпеки посилання мають обмежений строк дії. Спробуйте запросити нове посилання."
    },
    "invalid": {
      "title": "Посилання більше не працює",
      "perex": "Вказане посилання є неактивним.Це могло трапитись через його повторне використання або зміну умов."
    },
    "tokenCreated": {
      "title": "Посилання було відправлено.",
      "perex": "На Вашу корпоративну електронну пошту було відправлено нове посилання. Завершіть активацію, преейшовши за наданим посиланням."
    }
  },
  "preventionForm": {
    "birthDate": {
      "title": "Дата народження",
      "errorText": "Заповніть дату народження.",
      "errorTextDate": "Дата народження вказана в неправильному форматі.",
      "errorTextBirthDateRange": "Вкажіть правильну дату народження."
    },
    "gender": {
      "title": "Стать",
      "selectGender": "Виберіть стать",
      "errorText": "Виберіть стать.",
      "male": "Чоловік",
      "female": "Жінка",
      "other": "Інша"
    },
    "address": {
      "placeholder": "Введіть місце розташування"
    }
  },
  "ulekareContacts": {
    "email": "info@ulekare.cz",
    "phone": "+420&nbsp;227&nbsp;072&nbsp;720",
    "hours": "Пн-Пт 8.00–17.00&nbsp;год"
  },
  "authorizationPage": {
    "successText": "Ми успішно підтвердили, що Ви маєте право на безкоштовну послугу.",
    "prevention": {
      "title": "Дякуємо. Авторизація пройшла успішно.",
      "subtitle": "Натисніть на посилання, надіслане на електронну адресу <strong class=\"text-primary\">{email}</strong>."
    }
  },
  "renewPassword": {
    "title": "Скидання пароля",
    "subtitle": "Створіть новий пароль для свого облікового запису. Ми рекомендуємо створити надійний пароль, який містить принаймні одну цифру та літеру.",
    "setPassword": "Введіть свій пароль",
    "setPasswordAgain": "Введіть пароль ще раз",
    "newPassword": "Новий пароль",
    "changePassword": "Поміняти пароль",
    "minLengthError": "Пароль повинен містити не менше 5 символів.",
    "requiredErrorText": "Створіть пароль (мінімум 5 символів).",
    "generatedError": {
      "start": "Hпароль повинен",
      "minLength": "мати довжину не менше {length} символів",
      "and": "і",
      "require": "містити",
      "oneChar": "буква",
      "oneNumber": "цифру",
      "specialChar": "особливий символ"
    },
    "sameAsPasswordErrorText": "Паролі не збігаються.",
    "successMessage": "Пароль успішно змінено.",
    "invalidToken": {
      "title": "Посилання недійсне",
      "perex": "Щоб створити нове посилання, натисніть на \"Забули пароль\" в мобільному додатку uLékaře.cz."
    },
    "usedToken": {
      "perex": "Це посилання більше не працює, оскільки воно вже було використано один раз."
    },
    "expiredToken": {
      "title": "Термін дії посилання закінчився.",
      "perex": "Щоб створити нове посилання, натисніть на \"Забули пароль\" в мобільному додатку uLékaře.cz."
    },
    "nextButton": "Увійдіть в систему {service}"
  },
  "emailVerification": {
    "successMessagePerex": "Ми успішно перевірили вашу електронну адресу. Ви можете увійти.Ми успішно перевірили вашу електронну адресу. Ви можете увійти.",
    "button": "Продовжити до {service}",
    "invalidToken": "Посилання недійсне.",
    "usedToken": "Це посилання більше не дійсне, оскільки воно вже було використано один раз.",
    "expiredToken": "Термін дії посилання закінчився."
  },
  "unsupportedBrowser": {
    "title": "Використайте інший браузер",
    "perex": "Цей старий браузер, який ви використовуєте, більше не підтримує наш сервіс. Будь ласка, оновіть його або скористайтеся одним із цих браузерів."
  },
  "login": {
    "banner": {
      "title": "Ваші дані залишаться в безпеці.",
      "subtitle": "Ми постійно вдосконалюємо uLékaře.cz,  щоб ваші дані були вашими."
    },
    "socials": {
      "facebook": "Увійти за допомогою Facebook",
      "google": "Увійти за допомогою Google",
      "apple": "Увійти за допомогою Apple"
    },
    "title": "Увійти",
    "subtitle": "Для використання сервісів uLékaře.cz увійдіть в систему",
    "loginError": "Можливо, друкарська помилка, можливо, неправильні дані. Будь ласка, спробуйте ще раз.",
    "forgetPassword": "Забули пароль?",
    "password": {
      "title": "Пароль",
      "requiredError": "Потрібен пароль"
    },
    "remember": "Запам'ятати дані для входу в систему",
    "login": "Увійти",
    "noAccount": "У вас є лікар в кишені?",
    "registration": "Зареєструйтеся прямо зараз.",
    "registrationHeaderButton": "Зареєструйтеся прямо зараз"
  },
  "registration": {
    "title": "Реєстрація",
    "subtitleFirstStep": "Зареєструйтесь, щоб отримати доступ до медичної допомоги uLékaře.cz.",
    "subtitle": "Тільки медична команда знає ваші дані uLékaře.cz.",
    "addData": {
      "title": "Заповнення даних",
      "subtitle": "Ви увійшли в систему! Додайте більше особистої інформації, щоб медична команда могла зв'язатися з вами."
    },
    "emailError": "Ви вже зареєстрували цю електронну адресу.",
    "email": {
      "errorEmailNotExisting": "Введіть існуючу адресу електронної пошти.",
      "errorInvalidDomain": "Будь ласка, використовуйте електронний лист із увімкненим доменом (наприклад, @seznam.cz, @gmail.com...)",
      "errorText": "Будь ласка, заповніть свою адресу електронної пошти.",
      "title": "Особиста електронна пошта"
    },
    "socials": {
      "facebook": "Зареєструйтесь через Facebook",
      "google": "Зареєструйтесь через Google",
      "apple": "Зареєструйтесь через Apple"
    },
    "loginText": {
      "link": "Увійдіть до системи",
      "suffix": ", будь ласка",
      "question": "Ця електронна адреса вже зареєстрована."
    },
    "login": {
      "text": "У Вас вже є обліковий запис?",
      "link": "Увійдіть до системи."
    },
    "finishRegistration": "Повна реєстрація",
    "legal": {
      "text": "Погоджуюсь з {termsAndConds}.",
      "termsConditions": "умовами використання",
      "privacyPolicy": "Принципів  захисту особистих даних."
    }
  },
  "missingProfileData": {
    "title": "Заповнення даних",
    "titleLegal": "Підтвердження згод",
    "text": "Нам не вдалося отримати електронну адресу, необхідну для зв'язку з вами, із пов'язаного облікового запису. Будь ласка, заповніть її нижче.",
    "textLegal": "Будь ласка, підтвердьте наступне:"
  },
  "phoneVerification": {
    "title": "Підтвердження номера телефону",
    "subtitle": "Ми відправили SMS-код підтвердження на ваш номер {phone}. Будь ласка, введіть його нижче.",
    "label": "Код з SMS",
    "changeNumber": "Змінити номер",
    "inputError": "Код є обов'язковим",
    "codeError": "Введений вами код недійсний. Потрібна порада?",
    "sendAgain": "Надіслати код ще раз",
    "verify": "Перевірити",
    "error": {
      "error_timeout": {
        "title": "Будь ласка, дочекайтеся SMS підтвердження",
        "perex": "Ймовірно, ви просили змінити номер телефону кілька разів поспіль. Будь ласка, зачекайте, щоб не отримувати кілька повідомлень одночасно."
      },
      "error_block": {
        "title": "Ми заблокували ваш обліковий запис. Про всяк випадок...",
        "perex": "Безпека для нас понад усе, тому ми тимчасово заблокували ваш обліковий запис через підозрілу активність. Наша служба підтримки клієнтів буде рада Вам допомогти.",
        "callUs": "Зателефонуйте нам",
        "writeUs": "Зв'язатися з нами"
      }
    }
  },
  "lostPassword": {
    "title": "Забутий пароль",
    "subtitle": "Ви отримаєте посилання для відновлення паролю, якщо цю електронну адресу було зареєстровано на нашому веб-сайті або у мобільному додатку.",
    "button": "Відновити пароль",
    "linkSentTitle": "Відправлено",
    "linkSentPerex": "Лист для відновлення паролю був відправлений на {email}. Якщо ви не бачите листа, перевірте папку \"Спам\".",
    "sendLinkAgain": "Надіслати імейл ще раз",
    "finishRegistration": "Завершити реєстрацію"
  },
  "profileSection": {
    "menu": {
      "profile": "Мій обліковий запис",
      "subscription": "Підписка",
      "logout": "Вихід"
    },
    "badge": {
      "self": "самоплатники",
      "premium": "заплачено"
    },
    "freeService": {
      "title": "Безкоштовний сервіс",
      "text": "Ця послуга часто оплачується партнерами, роботодавцями та страховими компаніями.",
      "button": "Чи маю я право?"
    },
    "thankYou": "Послугу Вам оплачує {partnerName}.",
    "thankYouSelf": "Ви платите за послугу.",
    "thankYouHost": "Послугу Вам оплачує {host}."
  },
  "dashboard": {
    "menu": {
      "home": "Огляд",
      "questions": "Консультація",
      "appointments": "Запис на прийом",
      "prevention": "Профілактика",
      "explore": "Відкрийте для себе нове"
    },
    "personalInfoAssurance": {
      "prefix": "Як ми будемо з вами спілкуватися?",
      "email": "Електронна пошта",
      "phone": "Телефон"
    },
    "deactivatedUser": "<strong>Ваш обліковий запис деактивовано.</strong> <span class='black--text'>Що сталося? Зв'язатися з нами: <a href='mailto:{email}'>{email}</a> або тел. {phone}.</span>",
    "title": "Вітаємо Вас! 👋",
    "subtitle": "Чим ми можемо Вам допомогти?",
    "needAdvice": "Написати питання",
    "needAppointment": "Я хочу записатись на прийом",
    "needHelp": "Потрібна порада?",
    "supportBox": {
      "openTitle": "Важливі контакти",
      "title": "Підтримка клієнтів",
      "boxText": "Ми готові допомогти вам, чого б ви не потребували.",
      "chat": {
        "icon": "chat"
      },
      "customerService": {
        "title": "Клієнтська лінія",
        "buttonEmail": {
          "text": "ua@ulekare.cz"
        },
        "buttonPhone": {
          "text": "+420 227 072 720",
          "subtitle": ""
        },
        "linkEmail": "mailto:ua@ulekare.cz",
        "linkPhone": "tel:+420 227 072 720",
        "icon": "care"
      },
      "assistanceService": {
        "icon": "happy"
      },
      "covidService": {
        "icon": "lungs"
      },
      "unavailableOn": "Звертаємо вашу увагу, що {date} служба підтримки клієнтів та служба обробки замовлень працюватимуть в обмеженому режимі. Обробка поданих запитів може зайняти більше часу, ніж зазвичай. Для отримання загальної інформації, будь ласка, напишіть нам на вказану електронну адресу. \nДякуємо за розуміння.",
      "outageActive": "false",
      "outageDateISO": "2026-04-09"
    },
    "freeService": "Чи є у мене безкоштовна послуга?",
    "requestSent": "Завершить активацію в робочій електронній пошті",
    "hint": {
      "subtitle": "співзасновник uLékaře.cz, хірург",
      "text": "Світить сонце, все росте, цвіте. Що сталося? Настала весна!<br/>А разом з нею алергія, весняна втома, засмагла шкіра, виступаючі родимі плями...",
      "linkText": "Мені потрібна порада"
    },
    "questions": {
      "myQuestions": "Мої запитання",
      "updated": "У нас є відповідь для вас!",
      "resolvers": "Вони піклуються про вас",
      "sla": "Ми відповімо до <strong class=\"black--text\">{hour}</strong> год."
    },
    "appointments": {
      "myAppointments": "Моє замовлення"
    },
    "videoCall": {
      "buttonText": "Запланувати відеодзвінок",
      "buttonTextMobile": "Відеодзвінок"
    },
    "services": {
      "question": {
        "title": "Консультації (24/7)",
        "subtitle": "з&nbsp;відповіддю&nbsp;до&nbsp;{hours}&nbsp;год",
        "b2cSufix": "за&nbsp;{priceCzk}&nbsp;крон",
        "text": "Лікарі загальної практики та фахівці в одному місці. Для вас вдень і вночі.",
        "button": "Мені потрібна порада"
      },
      "videoCall": {
        "title": "Відеодзвінок",
        "subtitle": "з лікарем",
        "text": "Лікарі приділять Вам до 20 хвилин на відеодзвінок у зручний для Вас час.",
        "button": "Запланувати відеодзвінок"
      },
      "appointment": {
        "title": "Запис на прийом",
        "subtitle": "",
        "text": "Медсестри допоможуть вам знайти потрібного вам лікаря.",
        "button": "Хочу записатись на прийом"
      },
      "prevention": {
        "title": "Профілактика",
        "subtitle": "здоров'я в ваших руках",
        "text": "Здоров'я - Ваше. І ми будемо раді допомогти Вам подбати про нього.",
        "existedButton": "Розпочати профілактику"
      },
      "thematic_counseling": {
        "title": "Тематичні консультування",
        "text": "Печінка чи шкіра? Запитайте в онлайн-консультаціях, що спеціалізуються на конкретній темі здоров'я.",
        "button": "Вибрати консультацію"
      },
      "hints": {
        "service_not_supported_in_this_language": {
          "text": "Сервіс не може бути використаний {language}. Будь ласка, виберіть іншу мову в налаштуваннях <a href=\"{link}\" class=\"link--inline\">вашого профілю</a>.",
          "cs": "чеською",
          "en": "англійською",
          "sk": "словацькою"
        }
      }
    },
    "news": "Новини",
    "recomended": "Рекомендуємо",
    "errors": {
      "emailNotVerified": "Будь ласка, підтвердьте адресу електронної пошти, вказану під час реєстрації. Нехай у Вас буде uLékaře.cz під рукою!",
      "resendEmail": "Надіслати електронний лист ще раз."
    },
    "family": {
      "title": "Ви хочете запитати про своє здоров'я?",
      "myHealth": "Так, про моє здоров'я",
      "otherHealth": "Ні, за здоров'я когось із членів сім'ї"
    },
    "emailVerification": {
      "title": "Підтвердьте свою адресу електронної пошти",
      "subtitle": "PПерейдіть до своєї поштової скриньки <strong>{email}</strong> та натисніть на посилання для підтвердження в електронному листі, який ми Вам надіслали.",
      "text": [
        {
          "title": "Ви не отримали повідомлення?",
          "list": [
            {
              "icon": "check_circle",
              "text": "Ви можете знайти його в папці \"масова розсилка\" або \"небажана пошта\" (spam)."
            },
            {
              "icon": "check_circle",
              "text": "Це може зайняти кілька хвилин. Все ще нічого не відбувається? Спробуйте надіслати електронний лист ще раз."
            }
          ]
        },
        {
          "text": "Неважливо. Зареєструйтесь ще раз."
        }
      ],
      "actions": {
        "right": {
          "type": "resend",
          "baseText": "Надіслати електронний лист ще раз"
        }
      }
    },
    "help": {
      "text": "Потребуєте порадити?",
      "hours": "Пн-Пт 8:00-17:00"
    }
  },
  "profileAuthorization": {
    "chooseSubscription": "Виберіть підписку",
    "language": {
      "title": "Налаштування сервісу",
      "text": "Виберіть, якою мовою Ви хочете користуватися послугою.",
      "errorText": "Ваш платник не підтримує цю мову, будь ласка, виберіть іншу."
    },
    "final": {
      "title": "Дякуємо Вам за реєстрацію!",
      "text": "Відтепер послуга uLékaře.cz у вас в кишені! Наші лікарі та медсестри будуть раді Вам допомогти."
    },
    "possiblePartners": {
      "title": "Гарні новини! Скоріше за все, Ви маєте право на безкоштовну послугу.",
      "textHrb": "Підтвердьте, хто оплачує Ваші послуги, і допоможіть вам на шляху до здоров'я. Не можете вибрати? Ознайомтеся з нашим списком партнерів.",
      "changePartner": "Вибрати зі списку"
    },
    "hrbPartner": {
      "title": "Запустіть сервіс безкоштовно",
      "textBoth": "Введіть адресу електронної пошти компанії або код, який ви отримали від {partner}.",
      "textEmail": "Введіть адресу електронної пошти вашої компанії.",
      "textCode": "Введіть код активації, який ви отримали від {partner}.",
      "tabs": [
        "Електронною поштою",
        "Кодом"
      ],
      "email": "Електронна пошта компанії",
      "code": "Код активації",
      "codeError": "<strong>На жаль, цей код недійсний.</strong><br>Перевірте правильність коду у відділі кадрів.<br>Якщо код правильний, ми з радістю допоможемо вам у",
      "emailError": "Неправильна адреса електронної пошти. Ви не знаєте, що з ним робити? Зв'яжіться з нами <a href='mailto:info@ulekare.cz'>info@ulekare.cz</a>.",
      "invalidEmployeeEmail": "Роботодавець / партнер не включив безкоштовну послугу для цієї адреси електронної пошти",
      "benefitBlocked": "Цей електронний лист вже пов'язаний з іншим роботодавцем / партнером, тому ви не можете активувати послугу тут безкоштовно."
    },
    "emailAuthorization": {
      "title": "Дякуємо Вам за проявлений інтерес до безкоштовної активації сервісу!",
      "text": [
        {},
        {
          "title": "Ви ввели неправильну адресу електронної пошти?",
          "link": {
            "type": "router",
            "routerAction": "replace",
            "name": "dashboard",
            "query": {
              "a_step": "authorization"
            }
          }
        }
      ],
      "actions": {
        "left": {
          "type": "resend",
          "class": "light",
          "baseText": "Надіслати ще раз"
        },
        "right": {
          "type": "continue"
        }
      }
    },
    "authorizationSignpost": {
      "title": "Хто платить за послугу?",
      "text": "Користуйтеся послугами uLékaře.cz безкоштовно! Можливо, ваш роботодавець або один із наших партнерів (страхові компанії, компанії-емітенти кредитних карток тощо) оплатить це.",
      "employees": "Роботодавець",
      "search": "Пошук роботодавця по імені",
      "searchSignText": "Почніть писати назву компанії, в якій ви працюєте. Разом ми знайдемо її.",
      "searchEmpty": {
        "title": "З назвою \"{text}\" ми нічого не змогли знайти",
        "text": "Якщо ви вважаєте, що він не повинен бути відсутнім у нашому списку, ви можете надати його нам {email}.",
        "emailText": "рекомендувати"
      },
      "selfPay": "Оплачую самостійно"
    },
    "selfPay": {
      "title": "Оплачую самостійно",
      "text": "Ми все організуємо для вас:",
      "price": "{priceCzk} крон",
      "priceSufix": "/запит",
      "list": [
        {
          "icon": "doctor",
          "text": "Зв'язок з лікарем до 8 годин"
        },
        {
          "icon": "shield",
          "text": "Профілактична програма безпосередньо для вашого організму"
        },
        {
          "icon": "news",
          "text": "Практичні поради по здоров'ю від лікарів"
        }
      ]
    },
    "mastercard": {
      "title": "Підтвердьте свою картку Mastercard<sup>®</sup>",
      "codeInvalidError": "Введений вами номер недійсний. Переконайтеся, що ви ввели 6 номерів вашої преміальної картки або картки компанії Mastercard<sup>®</sup>.",
      "label": "Перші 6 цифр карти"
    },
    "external": {
      "titleSlot": "Невірна перевірка безкоштовного сервісу",
      "vozpText": "Як клієнт VoZP, увійдіть на клієнтський портал VoZP і натисніть на логотип uLékaře.cz. після першого входу для вас відкриються всі наші сервіси.",
      "ozpText": "клієнти OZP-це послуга uLékaře.cz доступна 24/7 через VITAKARTA. Увійдіть у свій обліковий запис VITAKARTY.",
      "drmaxText": "Як клієнт Dr. Max, увійдіть на вкладку \"переваги\" та натисніть на логотип uLékaře.cz.",
      "fairsuranceText": "Щоб активувати безкоштовну послугу, введіть код авторизації, який ви отримали від Fairsurance.",
      "eonText": "Безкоштовний сервіс для постійних клієнтів E.ON, на жаль,завершений. Сервіс uLékaře.cz ви можете продовжувати використувувати, увійшовши у свій профіль.",
      "sporthelpText": "{title}Щоб активувати безкоштовну послугу для учасників SportHelp, перейдіть за посиланням для використання послуги, яку можна знайти у вашій цифровій картці учасника в розділі \"Медична клініка\" uLékaře.cz або Запис uLékaře.cz.",
      "defaultErrorText": "Посилання для авторизації більше не може бути використане, оскільки термін  дії закінчився. Дякуємо за розуміння."
    },
    "chooseDifferentCompany": "Вибрати зі списку"
  },
  "profile": {
    "title": "Мій обліковий запис",
    "titleMobile": "Налаштування",
    "subtitle": "Керувати своїми даними.",
    "basicData": "Основні дані",
    "emailNote": "Змінити адресу електронної пошти неможливо.",
    "phoneNote": "Наші медсестри можуть зв'язатися з вами за цим номером, щоб уточнити ваші вимоги.",
    "security": "Безпека",
    "currentPassword": "Оригінальний пароль",
    "invalidCurrentPassword": "Невірний оригінальний пароль",
    "currentPasswordUsedInHistory": "Новий пароль не повинен збігатися зі старим.",
    "newPassword": "Новий пароль",
    "additionalInfo": "Додаткова інформація",
    "birthDateNote": "Залежно від Вашого віку лікар краще висловить свою думку",
    "address": "Адреса",
    "addressNote": "За адресою ми можемо знайти Вам відповідного лікаря.",
    "family": "Моя сім'я",
    "aboutApp": "Про додаток",
    "applicationLock": "Блокування додатку",
    "moreOptions": "Інші варіанти",
    "healthInsuranceProvider": {
      "title": "Медична страхова компанія",
      "note": "Ми шукаємо лікаря, що працює з вашою страховою компанією."
    },
    "applicationLanguage": {
      "title": "Мова додатку",
      "message": "Веб-сторінка буде показуватись цією мовою"
    },
    "serviceLanguage": {
      "title": "Мова обслуговування",
      "message": "Ваш лікар відповість вам цією мовою"
    },
    "changeLanguageNotification": {
      "text": "Після збереження змін мова сайту зміниться на",
      "cs": "чеську",
      "en": "англійську",
      "sk": "словацьку",
      "uk": "українську",
      "ru": "російську"
    },
    "storeMessage": {
      "success": "Зміни були збережені.",
      "error": "Зміни не були збережені. Перевірте точність наданих даних.",
      "passwordError": "Зміни не були збережені, оскільки оригінальний пароль був введений неправильно."
    },
    "ucb": {
      "title": "Юридичні документи та повідомлення",
      "text": "Будь ласка, зверніть увагу, що UniCredit Bank Czech Republic and Slovakia, a. s. не несе відповідальності за зміст і порядок надання послуг співробітнику. Використання даної послуги співробітником є добровільним, і відповідальність за надання послуги у вигляді медичної консультації несе компанія-постачальник послуг uLékaře.cz, s. r. o., яка несе відповідальність за те, що медична консультація надається виключно особою, кваліфікованою відповідно до чинного законодавства Чеської Республіки. Співробітникам рекомендується, перш ніж скористатися послугами медичної консультації, належним чином ознайомитися з {terms_and_conditions}.",
      "termsAndConditions": "умовами використання сервісу"
    },
    "removeSection": {
      "title": "Анулювання облікового запису",
      "button": "Анулювати обліковий запис"
    },
    "removeDialog": {
      "list": [
        {
          "icon": "chat-empty"
        },
        {
          "icon": "surgeon"
        },
        {
          "icon": "person-sad"
        }
      ]
    },
    "benefit": {
      "showMore": "Показати більше"
    },
    "appSecurity": "Безпека додатку"
  },
  "passwordRenewal": {
    "title": "Оновіть свій пароль.",
    "subtitle": "Вам потрібно оновити свій пароль, оскільки термін дії вашого пароля закінчився.",
    "currentPassword": "Поточний пароль:",
    "newPassword": "Новий пароль:",
    "passwordRules": "Ваш пароль повинен мати довжину не менше 8 символів і містити принаймні одну літеру, цифру та спеціальний символ (-=%*+./![]@#$^&()?;), і ви не повинні використовувати той самий пароль, який ви використовували в минулому.",
    "confirmation": "Підтвердіть свій новий пароль",
    "passwordsDontMatch": "Паролі не збігаються",
    "button": "Змінити пароль",
    "thankYouTitle": "Пароль було змінено",
    "thankYouSubtitle": "Ваш пароль успішно змінено. Дякуємо за співпрацю!"
  },
  "questions": {
    "title": "Консультація",
    "subtitle": "Стежте за своїми питаннями. Задавайте їх нашим лікарям.",
    "noQuestion": {
      "title": "Ще чекаємо на ваше перше запитання",
      "subtitle": "Чим ми можемо Вам допомогти?",
      "infoList": [
        {
          "text": "Ви швидко дізнаєтеся, чи зможете ви самостійно впоратися з несподіваною проблемою зі здоров'ям або необхідно звернутися за медичною допомогою.",
          "icon": "suitcase"
        },
        {
          "text": "Лікар з консультації направить вас на відповідне обстеження або до потрібного фахівця.",
          "icon": "surgeon-question"
        },
        {
          "text": "Наші фахівці допоможуть вам зорієнтуватися в медичному висновку або результатах лабораторних досліджень.",
          "icon": "stop"
        },
        {
          "text": "Не хвилюйтеся, ми допоможемо вам впоратися з вашими проблемами зі здоров'ям.",
          "icon": "temperature"
        }
      ]
    },
    "newQuestion": "Новий запит",
    "newSolved": "Прочитайте відповідь",
    "waitingForAnswer": "Чекаємо відповіді",
    "history": "Історія запитів",
    "detail": {
      "title": "Деталь запиту",
      "sent": "Відправлено",
      "questionFormTitle": "Опис проблеми зі здоров'ям",
      "healthFormTitle": "Стан здоров'я",
      "attachments": "Докладання",
      "helped": "Чи допомогла вам ця відповідь?"
    },
    "evaluation": {
      "title": "Дякую вам за вашу відповідь",
      "text": "Ви допомагаєте нам покращувати наші послуги. Ви хочете розповісти нам щось інше?",
      "label": "Інші коментарі",
      "placeholder": "Як ми можемо покращити сервіс?",
      "ok": "Відповідь мені допомогла",
      "nok": "Відповідь мені не допомогла"
    },
    "thankYou": {
      "title": "Ваш запит успішно надіслано",
      "subtitle": "(Послуга надаватиметься {language})",
      "cs": "чеською",
      "en": "англійською",
      "sk": "словацькою",
      "text": "Зараз ним займається лікар загальної практики, і як тільки він відповість на ваші запитання, ми повідомимо вас електронною поштою."
    },
    "status": {
      "waitingGpAnswer": "На ваше запитання відповість лікар загальної практики.",
      "waitingSpecialistAnswer": "На ваше запитання відповість фахівець.",
      "answered": "На ваше запитання дано відповідь.",
      "transferToAppointment": "Ваш запит перетворено на замовлення. Ми зв'яжемося з вами.",
      "declined": "Ваш запит було відхилено.",
      "emergency": "На ваше запитання дано відповідь. Це може бути небезпечним для життя станом, негайно зверніться за медичною допомогою."
    },
    "askedQuestions": "Розставлені запитання"
  },
  "appointments": {
    "title": "Моє замовлення",
    "subtitle": "Наші медсестри будуть раді допомогти вам знайти потрібного лікаря / спеціаліста або зателефонувати вже наявному лікарю.",
    "statuses": {
      "newDoctor": "Ми знайшли лікаря!",
      "newZZ": "Ми знайшли, де вам допоможуть!"
    },
    "noAppointments": {
      "title": "Ви ще не пробували робити замовлення через uLékaře.cz.",
      "subtitle": "Як працює замовлення uLékaře.cz?",
      "infoList": [
        {
          "text": "Ми допомагаємо з оформленням записів на прийом по всій Чехії та Словаччині.",
          "icon": "hospital"
        },
        {
          "text": "Медсестра зв'яжеться з вами наступного робочого дня, і ви  домовитесь про все необхідне, щоб якомога швидше потрапити до потрібного лікаря.",
          "icon": "nurse"
        },
        {
          "text": "Залиште пошук лікарів і  дзвінки до кабінетів нам.",
          "icon": "clock"
        }
      ]
    },
    "newAppointment": "Нове замовлення",
    "activeAppointments": "Оформлюємо",
    "visitAppointments": "Не забудьте відвідати до лікаря",
    "evaluateAppointments": "Оцініть відвідування лікаря",
    "history": "Виконані замовлення",
    "evaluation": {
      "ok": "Задоволення візитом",
      "nok": "Невдоволення візитом",
      "noVisit": "Ніякого візиту до лікаря не було"
    },
    "detail": {
      "title": "Деталі замовлення",
      "sent": "Відправлено",
      "date": "Термін запису на прийом: ",
      "visitAt": "Коли прибути: ",
      "facility": "Медична установа: ",
      "address": "Адреса: ",
      "doctor": "Лікар: ",
      "phone": "Телефон: ",
      "note": "Примітка:",
      "dateMandatory": "Вищевказаний термін є обов'язковим!",
      "unableToVisitInfo": "Якщо ви не можете прийти на прийом до  лікаря, будь ласка, зателефонуйте по {phone} або напишіть на <a href=\"mailto:{email}\">{email}</a>.",
      "thankYou": "Ми віримо, що рекомендований нами лікар допоможе вам у вирішенні ваших проблем зі здоров'ям. Будь ласка, повідомте нам, чи все пройшло добре. Дякуємо!",
      "additionalQuestion": "У мене є додаткове запитання",
      "changeDate": "Змінити дату",
      "cancelAppointment": "Скасувати прийом",
      "helped": "Як ви оцінюєте прийом?",
      "noVisit": "Не відбувся"
    },
    "thankYou": {
      "subtitle": "(Ми будемо спілкуватися {language})",
      "cs": "чеською",
      "en": "англійською",
      "sk": "словацькою",
      "text": "Наша медсестра зателефонує вам на наступний робочий день з вказаного номера  +420 227 072 720.",
      "others": {
        "text": "Медсестра запитає цю інформацію про людину, до якої належить замовлення:",
        "items": [
          {
            "icon": "register",
            "text": "Страховий номер та страхова компанія"
          },
          {
            "icon": "person-happy",
            "text": "поточний стан здоров'я"
          },
          {
            "icon": "chat-empty",
            "text": "зроблені обстеження та наявність направлення до лікаря"
          },
          {
            "icon": "clock",
            "text": "доступність часу"
          }
        ]
      }
    },
    "status": {
      "waiting": "Ваше замовлення чекає обробки. Зачекайте, ми Вам передзвонимо.",
      "lookingForDoctor": "Ми працюємо над пошуком відповідного лікаря.",
      "orderedForTime": "Прийом у Вашого лікаря запланований на {datetime} год.",
      "orderedForOpeningHours": "Замовлення оформлено. Відвідайте лікаря протягом робочих годин.",
      "sendContact": "Надіслано контакт на лікаря.",
      "done": "Запит на замовлення було оброблено.",
      "cancelled": "Замовлення було скасовано."
    }
  },
  "prevention": {
    "title": "Почніть з профілактики. Здоров'я- ваше.",
    "subtitle": "Всього кілька особистих даних і ми підготуємо ваш організм до профілактики. Запобігати проблемам зі здоров'ям буде набагато простіше.",
    "birthDateNote": "Вік - це просто цифра. Нам потрібно це знати, щоб забезпечити вам правильний догляд.",
    "healthInsuranceProviderNote": "Ви побачите внески вашої страхової компанії, і ми також допоможемо вам записатися на прийом до співпрацюючих лікарів.",
    "personalization": {
      "title": "Ваші профілактичні заходи за віком",
      "text": "При вимкненні ви також побачите профілактичні огляди, які зазвичай проводяться пізніше в житті."
    },
    "start": "Почати з профілактики",
    "thankYou": {
      "title": "Ось і все! Дякуємо вам за те, що вказали всі деталі.",
      "text": "Завдяки профілактичному догляду ви уникнете проблем зі здоров'ям і хвороб. Поради щодо охорони здоров'я та новини можна регулярно отримувати електронною поштою."
    },
    "summary": {
      "title": "Профілактика",
      "subtitleDesktop": "Ми допоможемо вам залишатися на крок попереду хвороби.",
      "subtitleMobile": "На крок попереду хвороби.",
      "showAll": "Показати все",
      "intervalEnds": "Запишіться найближчим часом",
      "planned": "Заплановано",
      "plannedOn": "Заплановано на {time}",
      "timeline": {
        "title": "Випливає",
        "tooltip": "Тут ви побачите найближчі огляди та щеплення - Ви вже записані??"
      },
      "examinations": {
        "title": "Профілактичні огляди",
        "tooltip": "Тут ви знайдете дати профілактичних оглядів і всю інформацію, що на вас чекає."
      },
      "vaccinations": {
        "title": "Вакцинація",
        "tooltip": "Тут ви знайдете дати вакцинації та всю інформацію, що на вас чекає."
      },
      "others": {
        "title": "Корисна інформація"
      }
    },
    "list": {
      "examinations": {
        "recommended": "Обовʼязкові профілактичні огляди",
        "optional": "Добровільні профілактичні огляди"
      },
      "vaccinations": {
        "recommended": "Обов'язкові щеплення",
        "optional": "Добровільні щеплення"
      }
    }
  },
  "payment": {
    "title": "Виберіть спосіб оплати",
    "priceSum": "До оплати: {price} CZK",
    "voucher": "Ваш код ваучера",
    "voucherGroup": "Ваучером {region}",
    "voucherApply": "Застосовувати",
    "pay": "Оплатити ({price} CZK)",
    "payment_created": "Оплата ще не проведена.",
    "payment_confirmed": {
      "title": "Питання задано!",
      "subtitle": "Чудово, питання вже в дорозі, і ми незабаром зв'яжемося з вами, щоб відповісти на Вашу проблему. Не хвилюйтеся, ми це виправимо! Довіртеся нам!"
    },
    "payment_canceled": "Платіж було скасовано.",
    "payment_rejected": "У вашому платежі було відмовлено.",
    "payment_create_error": "Помилка оплати. Спробувати знову.",
    "payment_timeouted": "Оплата не проведена. Спробувати знову.",
    "payment_in_progress": "Ми чекаємо вашої оплати.",
    "payment_wait": {
      "title": "Ми чекаємо підтвердження платежу.",
      "subtitle": "Як тільки платіж буде підтверджено, ми надішлемо запит лікарям."
    },
    "chooseDifferent": "Виберіть інший спосіб"
  },
  "loginBanner": {
    "title": "Ми - ваш провідник на шляху до здоров'я.",
    "infoList": [
      {
        "icon": "doctor",
        "text": "Лікарі загальної практики та спеціалісти відповідають на запитання."
      },
      {
        "icon": "nurse",
        "text": "Медсестри допоможуть із записом на прийом до лікаря."
      },
      {
        "icon": "shield",
        "text": "У ваших руках безпечне середовище."
      }
    ],
    "show": "Як працює ця послуга?",
    "hide": "Закрити"
  },
  "cookiesConsent": {
    "acceptAll": "Прийняти все",
    "basic": {
      "title": "Наш сайт працює як лікар",
      "perex": "Наш веб-сайт використовує файли cookie, а функціонує як лікар, який задає  питання, щоб допомогти вам найкращим чином. Таким чином, ми збираємо {technical}, {analytical} та {marketing} інформацію, щоб постійно вдосконалюватися та краще допомагати всім вам. Ви згодні?",
      "technical": "технічну",
      "analytical": "аналітичну",
      "marketing": "ділову",
      "customize": "Налаштування"
    },
    "settings": {
      "title": "Налаштування файлів cookies",
      "description": "Коли ви відвідуєте наш веб-сайт www.ulekare.cz сайт отримує або зберігає інформацію у вашому браузері, як правило, у вигляді файлів cookies. Це може бути інформація про вас, ваші уподобання та пристрої, якими ви користуєтесь. Зазвичай це робиться для вдосконалення сайту, щоб він працював відповідно до ваших очікувань. Як правило, ця інформація не ідентифікує вас як особистість, але загалом вона може допомогти адаптувати середовище до ваших потреб. Ми поважаємо ваше право на конфіденційність, тому ви можете відмовитися від використання певних файлів cookies, вибравши опцію нижче. Майте на увазі, що блокування деяких файлів cookie може вплинути на те, як працює сайт і які послуги будуть Вам Показані.",
      "link": "заяву про файли cookie знайдете {hereLink}.",
      "items": {
        "technical": {
          "title": "Технічні файли cookies",
          "bodyText": "Вони необхідні для функціонування нашого сайту, тому відключити їх неможливо. Зазвичай вони налаштовані так, щоб реагувати на вжиті вами дії, такі як запит послуг, що стосуються налаштувань безпеки, вхід в систему, заповнення форм і т.д. ви можете налаштувати свій браузер на блокування файлів cookies або відправку повідомлень про них. Ці файли cookies не зберігають жодної ідентифікованої інформації."
        },
        "functional": {
          "title": "Функціональні файли cookies",
          "bodyText": "За допомогою цих файлів cookies сайт стає більш потужним і персоналізованим. Вони можуть бути встановлені нами або сторонніми постачальниками, послугами яких ми користуємося на сайті. Якщо ви не дозволяєте використовувати ці файли cookies, можливо, деякі або всі ці служби можуть не працювати належним чином."
        },
        "analytics": {
          "title": "Аналітичні файли cookies",
          "bodyText": "Ці файли cookies використовуються для покращення функціонування веб-сайту. Вони дозволяють нам розпізнавати та відстежувати кількість відвідувачів та те, як вони використовують веб-сайт. Вони допомагають нам покращити роботу веб-сайту. Ці файли cookies не збирають інформацію, яка ідентифікує вас особисто."
        },
        "marketing": {
          "title": "Маркетингові файли cookies",
          "bodyText": "Вони використовуються для відстеження уподобань користувача веб-сайту з метою націлювання реклами, тобто відображення маркетингових та рекламних повідомлень (у тому числі на сторонніх сайтах) відповідно до цих уподобань. <strong>Маркетингові файли cookies використовують інструменти зовнішніх компаній. Ці маркетингові файли cookies будуть використовуватися лише за вашою згодою.</strong>"
        }
      },
      "save": "Зберегти налаштування"
    },
    "youtube": {
      "text": "Щоб переглянути відео, нам потрібно  підтвердити використання файлів cookies. Для отримання додаткової інформації дивіться {cookiePolicyLink}.",
      "cookiePolicyLinkText": "політика використання файлів cookies",
      "accept": "Погоджуюсь"
    }
  },
  "placeholders": {
    "date": {
      "year": "РРРР",
      "month": "ММ",
      "date": "ЧЧ"
    }
  },
  "putinSucks": {
    "helloImage": "hello-ua-tp-figure.svg",
    "helloImageAlt": "Лікарське консультування для біженців з України",
    "menu": {
      "question": "Проконсультуватися",
      "helpWith": "Як працює сервіс?",
      "logoText": "Ми за Україну"
    },
    "subTitle": "Консультація лікаря для українців",
    "doctorInfo": {
      "text": "“Не соромтеся звертатися до нас із будь-якою проблемою зі здоров'ям, яку вам потрібно вирішити у Чеській Республіці.\nНаші лікарі та медсестри, які розмовляють українською та російською мовами, будуть раді проконсультувати Вас.“",
      "name": "MUDr. Соня Боушкова",
      "position": "Головний лікар uLékaře.cz"
    },
    "infoTitle": "Як працює сервіс?",
    "infoListHeader": [
      {
        "icon": "icon-check-ua",
        "text": "Консультація лікаря по всій Чеській Республіці."
      },
      {
        "icon": "icon-check-ua",
        "text": "Лікарі і медичні сестри допоможуть на вашій рідній мові."
      },
      {
        "icon": "icon-check-ua",
        "text": "Ми спростили для вас послуги. Нам достатньо вашої електроної адреси та телефону."
      }
    ],
    "infoList": [
      {
        "icon": "ua/register",
        "text": "Опишіть свої потреби в бланку нижче."
      },
      {
        "icon": "ua/mail",
        "text": "Лікар вам відповість на електронну пошту."
      },
      {
        "icon": "ua/objednavky",
        "text": "Медсестри допоможуть вам із записом до лікаря."
      }
    ],
    "form": {
      "thankYou": {
        "title": "Ми будемо раді допомогти вам",
        "perex": "<p>Лікар зв'яжеться з вами через електронну пошту, якщо вам потрібно буде звернутися до лікаря, то з вами зв'яжеться медсестра.</p>"
      }
    },
    "footer": {
      "perex": "В uLekaře.cz віримо що здоров'я - понад усе. За допомогою технологій, людяності та професійності допомагаємо людям доглядати за своїм здоров'ям."
    }
  },
  "unavailableClinics": {
    "title": "Хвилиночку, ми оновлюємо!",
    "description": "Приносимо вибачення за короткочасний збій. Сервіс скоро відновиться... і навіть краще, ніж раніше."
  },
  "healthInsuranceProviderBenefits": {
    "title": "Оберіть свою страхову компанію"
  },
  "invitation": {
    "dashboard": {
      "title": "Запросіть сім'ю",
      "text": "Послуга uLékaře.cz для ваших близьких. Абсолютно безкоштовно.",
      "buttonText": "Поділитися запрошенням"
    },
    "title": "Здоров'я для всієї родини",
    "text": "Запросіть до 5 найближчих друзів. Завдяки Вам у них завжди під рукою безкоштовна онлайн-консультація лікарів і медсестер.",
    "list": [
      {
        "icon": "link",
        "text": "Скопіюйте своє унікальне посилання, щоб поділитися ним із родиною."
      },
      {
        "icon": "rodina",
        "text": "Надішліть його своїм близьким."
      },
      {
        "icon": "confetti",
        "text": "Після реєстрації послуга активується безкоштовно."
      }
    ],
    "shareLink": "Поділитися посиланням",
    "copyCode": "Скопіювати посилання",
    "codeCopied": "Копія",
    "familyTitle": "Кому я допомагаю",
    "remove": "Видалити",
    "shareTitle": "Послуга uLékaře.cz безкоштовна",
    "shareText": "{personName} ділюся з вами послугою uLékaře.cz у колі сім'ї. Просто зареєструйтесь за посиланням, і отримаєте її безкоштовно.",
    "emptyMemberName": "Член сім'ї"
  },
  "languageSwitcher": {
    "cz": "Čeština",
    "sk": "Slovenčina",
    "en": "English",
    "uk": "Українська",
    "ru": "Русский язык",
    "hu": "Magyar"
  },
  "aeskulab": {
    "title": "Запит на пояснення результатів лабораторніх тестів",
    "buttonText": "Заповнити заявку",
    "howItWorks": {
      "title": "Як це працює?",
      "items": [
        {
          "icon": "chat",
          "perex": "Надішліть заявку з доданим pdf-документом з результатами лабораторних досліджень."
        },
        {
          "icon": "mail",
          "perex": "Ми надішлемо вам пояснення лабораторних показників на Вашу електронну адресу протягом 24 годин"
        },
        {
          "icon": "calendar/date-31",
          "perex": "На наступний робочий день після відповіді лікаря медсестра зв'яжеться з вами і все обговорить."
        }
      ]
    },
    "form": {
      "thankYou": {
        "title": "Дякуємо Вам за відправку запиту.",
        "perex": "Ми щойно надіслали результати ваших лабораторних досліджень та всі дані для обробки.\nВи отримаєте відповідь лікаря на свою електронну адресу протягом 24 годин."
      },
      "personalData": {
        "text": "Я ознайомився з {link} постачальника медичних послуг uLékaře.cz Health Care.",
        "link": "принципами обробки персональних даних"
      },
      "termsConds": {
        "text": "Я ознайомився з {link} та {cookies} і я згоден з ними.",
        "link": "умовами використання платформи uLékaře.cz",
        "cookies": "політикою платформи щодо файлів cookies uLékaře.cz"
      }
    },
    "formTitle": "Форма заявки",
    "email": "health.care@ulekare.cz",
    "phone": "+420&nbsp;253&nbsp;253&nbsp;155",
    "formButtons": {
      "text": "Ми будемо використовувати дані з сайту cz.unilabs.online",
      "others": "Я запитую про іншу людину"
    },
    "emergency": "Служба uLékaře.cz це не заміна екстреним службам. У разі виникнення серйозних труднощів <a href=\"tel:155\" class=\"link--inline black--text\">телефонуйте на гарячу лінію 155</a>.",
    "footer": {
      "copyright": "&copy; {thisYear} uLékaře.cz Health Care, s.r.o.",
      "leftText": "Постачальник медичних послуг uLékaře.cz Health Care, s. r. o. функціонування веб-сайту забезпечується компанією uLékaře.cz, s. r. o.",
      "rightText": "Unilabs є оператором cz.unilabs.online і найбільшим постачальником лабораторних послуг та діагностики в Чеській Республіці."
    }
  },
  "feedback": {
    "text": "Ваша оцінка - наш вітамін. Ми покращуємо здоров'я цього додатка також завдяки вам.",
    "label": "Чи є у вас якісь ідеї щодо вдосконалення?",
    "placeholder": "Тут ви можете поділитися ними з нами...",
    "thankYou": {
      "title": "Дякуємо за ваш відгук",
      "text": "Ми зробимо все можливе, щоб полегшити ваше медичне обслуговування."
    },
    "menu": "Зворотний зв'язок",
    "panelButton": "Заповніть форму зворотного зв'язку"
  },
  "addressInput": {
    "country": "Держава"
  },
  "secondFactor": {
    "label": "Введіть код, який ви отримали для підтвердження входу.",
    "error": {
      "input": "Введіть код."
    }
  },
  "forms": {
    "Question": {
      "patient": {
        "birthNumber": {
          "self": {
            "label": "Номер страхового полісу",
            "help": "Номер страхового полісу полегшить нам запис на прийом до лікаря."
          },
          "other": {
            "label": "Номер страхового полісу",
            "help": "Номер страхового полісу полегшить нам запис на прийом до лікаря."
          }
        }
      },
      "questionBasic": {
        "questionWhat": {
          "label": "Опишіть проблему зі здоров'ям і всі її прояви. Чим докладніше опис, тим точніше відповідь лікаря."
        }
      },
      "questionAdditional": {
        "questionContact": {
          "yes": "Так, я хотів би, щоб зі мною зв'язалася медсестра.",
          "no": "Ні, я не хочу, щоб медсестра телефонувала."
        }
      }
    },
    "Order": {
      "patient": {
        "firstName": {
          "other": {
            "label": "Ім'я іншої людини"
          }
        },
        "birthNumber": {
          "self": {
            "label": "Номер страхового полісу",
            "help": "Номер страхового полісу полегшить нам запис на прийом до лікаря."
          },
          "other": {
            "label": "Номер страхового полісу",
            "help": "Номер страхового полісу полегшить нам запис на прийом до лікаря."
          }
        }
      },
      "orderBasic": {
        "orderWhat": {
          "label": "З якою проблемою зі здоров'ям вам необхідно записатися на прийом до лікаря?"
        },
        "orderSpecialist": {
          "label": "Якого лікаря чи спеціаліста ви шукаєте?"
        },
        "orderContact": {
          "label": "Як ви хочете, щоб я допоміг вам із замовленням?",
          "yes": "Я вважаю за краще взяти на себе весь процес замовлення.",
          "no": "Я вважаю за краще надіслати контакти."
        }
      }
    }
  }
}